export default {"src":"/_next/static/media/dark-purple-left.f7ca531b.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};